import {get, post, authHeader, post_1} from "../APIGateWay";

export async function getParentInfo(params = {}) {
    return await get(params, '/parent/parents-profile')
}

// export async function getParentReport(data) {
//     return await post(data, '/account-parent/parents-report')
// }

export async function getChildAccount(data) {
    return await post(data, '/account-parent/get-child-account')
}   

export async function getListChildAccount(data) {
    return await post(data, '/account-parent/get-list-child-account')
}

export async function getKeyAccount(data) {
    return await post(data, '/account-parent/get-key-account')
}

export async function sendConnect(data) {
    return await post(data, '/account-parent/send-connect-account')
}

export async function removeChild(data) {
    return await post(data, '/account-parent/remove-child')
}

export async function getAcademicReport(data) {
    return await post_1(data, process.env.VUE_APP_ECO_URL + '/api_eco.php/getclasslist')
}
export async function getCertificateReport(data) {
    return await post_1(data, process.env.VUE_APP_ECO_URL + '/api_eco.php/getschoolyearcc_all')
}

export async function getEbookReport(params = {}) {
    return await get(params, '/ebook/report')
}

export async function getParentReportGrade(params = {}) {
    return await get(params, '/parent/grade-report')
}

export async function getParentReportMonth(params = {}) {
    return await get(params, '/parent/month-report')
}

export async function getParentReport(params = {}) {
    return await get(params, '/parent/parents-report')
}

export async function getward(params = {}) {
    return await get(params, '/parent/list-ward')
}